import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth';
import {NavigationEnd, Router} from '@angular/router';
import {User} from '../../classes/user';
import {HttpErrorResponse} from "@angular/common/http";
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit, OnDestroy {
    signedIn: boolean = false;
    user: User = new User();
    mobileMenuOpen: boolean = false;
    private routerSub?: Subscription;

    constructor(private authService: AuthService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.loadUser();

        this.authService.userSignedIn
            .subscribe({
                    next: () => {
                        this.loadUser();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                }
            );

        this.authService.userSignedOut
            .subscribe({
                    next: () => {
                        this.signedIn = false;
                        this.user = new User();
                        this.closeMobileMenu();
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                }
            );

        this.routerSub = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => this.closeMobileMenu());
    }

    ngOnDestroy(): void {
        if (this.routerSub) {
            this.routerSub.unsubscribe();
        }
    }

    private loadUser(): void {
        this.authService.getUser()
            .subscribe({
                next: (user: any) => {
                    this.user = user;
                    this.signedIn = true;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    toggleMobileMenu(e: Event): void {
        e.preventDefault();
        e.stopPropagation();
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    closeMobileMenu(): void {
        this.mobileMenuOpen = false;
    }

    @HostListener('document:click')
    onDocumentClick(): void {
        this.closeMobileMenu();
    }

    signOut(e: any) {
        e.preventDefault();
        this.closeMobileMenu();
        this.authService.signOut();
        this.router.navigate(['/login']);
    }

}
